import useMountedQuery from 'Hooks/useMountedQuery';
import { getStudyLoadConfig }
	from 'Queries/GraphQlQueries/StudyPlan/StudyPlanQueries';

/**
 * Retrieve the period and term study load configuration for a given
 * study plan
 */
export const useStudyLoadConfig = (
	studyPlanId: string | undefined,
) => {
	return useMountedQuery(
		() => {
			if (!studyPlanId) {
				throw new Error('Query function call should be skipped if program version is not defined');
			}
			return getStudyLoadConfig(studyPlanId);
		},
		[studyPlanId],
		undefined,
		!studyPlanId,
	);
};
